/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

		// Use this variable to set up the common and page specific functions. If you
		// rename this variable, you will also need to rename the namespace below.
		var Sage = {
				// All pages
				'common': {
						init: function () {
								// JavaScript to be fired on all pages

								$('.search-trigger a').click(function (e) {
										e.preventDefault();
										$('#searchModal').modal('show');
										setTimeout(function () {
												$('#lg_search').focus();
										}, 500);
								});

								$('.menu-item-has-children > a').on('click hover', function (event) {
										var selectedItem = $(this);
										event.preventDefault();
										if (selectedItem.parent('li').hasClass('selected')) {
												selectedItem.parent('li').removeClass('selected');
										} else {
												$('.main-menu').find('.menu-item-has-children.selected').removeClass('selected');
												selectedItem.parent('li').addClass('selected');
										}
								});


								$("#mmenu").mmenu({
										// extensions: ["theme-black", "border-full"],
										// extensions 	: [ "shadow-panels", "fx-listitems-slide", "border-full", "theme-black", "position-left" ],
										// pageSelector: ".wrap",
										offCanvas: false,
										slidingSubmenus: false,
										navbar: {
												add: false
										},
								});
								var API = $("#mmenu").data("mmenu");

								$(".cd-nav-trigger").click(function (e) {
										e.preventDefault();
										$(this).toggleClass('active');
										console.log('OPEN / CLOSE MENU');
										$('#mmenu').toggleClass('active');
								});


								/*
			  			document.addEventListener(
                "DOMContentLoaded", () => {
                    new Mmenu( "#my-menu", {
                       "navbars": [
                          {
                             "position": "bottom",
                             "content": [
                                "<a class='fa fa-envelope' href='#/'></a>",
                                "<a class='fa fa-twitter' href='#/'></a>",
                                "<a class='fa fa-facebook' href='#/'></a>"
                             ]
                          }
                       ]
                    });
                }
            	);
							*/


						},
						finalize: function () {
								// JavaScript to be fired on all pages, after page specific JS is fired
						}
				},
				// Home page
				'home': {
						init: function () {
								// JavaScript to be fired on the home page
						},
						finalize: function () {
								// JavaScript to be fired on the home page, after the init JS
						}
				},

				// register page
				'register': {
						init: function () {


								// Read a page's GET URL variables and return them as an associative array.
								function getUrlVars() {
										var vars = [],
												hash;
										var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
										for (var i = 0; i < hashes.length; i++) {
												hash = hashes[i].split('=');
												vars.push(hash[0]);
												vars[hash[0]] = hash[1];
										}
										return vars;
								}
								var memberType = getUrlVars()["member-type"];


								if (memberType == "client") {

										$(".bmt-member-type option[value='boardmembers']").hide();
										$(".bmt-member-type option[value='consultants']").hide();
										$(function () {
												$('input#field_reg_groups_1').prop('checked', true);
										});

								} else if (memberType == "consultant") {
										$(".bmt-member-type option[value='boardmembers']").hide();
										$(".bmt-member-type option[value='clients']").hide();
										$(function () {
												$('input#field_reg_groups_2').prop('checked', true)
										});

								} else if (memberType == "board-member") {
										$(".bmt-member-type option[value='consultants']").hide();
										$(".bmt-member-type option[value='clients']").hide();
										$(function () {
												$('input#field_reg_groups_2').prop('checked', true)
										});

								} else {
										$(".standard-form").empty();
										//$( "#register-page" ).html( "<h2>Oops! Something isn't right here!</h2><p>Please check to make sure you have the correct URL</p>" );
								}


						},
						finalize: function () {
								// JavaScript to be fired on the home page, after the init JS
						}
				},


				// About us page, note the change from about-us to about_us.
				'single_post': {
						init: function () {
								// JavaScript to be fired on the about us page

								$('table').stacktable({
										myClass: 'table'
								});


								$("a[href*=\\#]:not([href=\\#]).navigation__link").bind('click', function (e) {
										e.preventDefault(); // prevent hard jump, the default behavior

										var target = $(this).attr("href"); // Set the target as variable

										// perform animated scrolling by getting top-position of target-element and set it as scroll target
										$('html, body').stop().animate({
												scrollTop: $(target).offset().top
										}, 600, function () {
												location.hash = target; //attach the hash (#jumptarget) to the pageurl
										});

										return false;
								});


								$(window).scroll(function () {
										var scrollDistance = $(window).scrollTop();

										// Show/hide menu on scroll
										//if (scrollDistance >= 850) {
										//		$('nav').fadeIn("fast");
										//} else {
										//		$('nav').fadeOut("fast");
										//}

										// Assign active class to nav links while scolling
										$('.page-section').each(function (i) {
												if ($(this).position().top <= scrollDistance) {
														$('.navigation a.active').removeClass('active');
														$('.navigation a').eq(i).addClass('active');
												}
										});
								}).scroll();


						}
				}
		};

		// The routing fires all common scripts, followed by the page specific scripts.
		// Add additional events for more control over timing e.g. a finalize event
		var UTIL = {
				fire: function (func, funcname, args) {
						var fire;
						var namespace = Sage;
						funcname = (funcname === undefined) ? 'init' : funcname;
						fire = func !== '';
						fire = fire && namespace[func];
						fire = fire && typeof namespace[func][funcname] === 'function';

						if (fire) {
								namespace[func][funcname](args);
						}
				},
				loadEvents: function () {
						// Fire common init JS
						UTIL.fire('common');

						// Fire page-specific init JS, and then finalize JS
						$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
								UTIL.fire(classnm);
								UTIL.fire(classnm, 'finalize');
						});

						// Fire common finalize JS
						UTIL.fire('common', 'finalize');
				}
		};

		// Load Events
		$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
